export function getSidebearingTransactionLabel(side) {
    return side === 'left' ? 'Set LSB' : 'Set RSB';
}
export function formatSidebearingHistoryValue(side, value) {
    return `${side.toUpperCase()} ${value}`;
}
export function inferSidebearingSideFromHistoryItem(historyItem) {
    if (!historyItem) {
        return null;
    }
    if (historyItem.transactionLabel === 'Set LSB') {
        return 'left';
    }
    if (historyItem.transactionLabel === 'Set RSB') {
        return 'right';
    }
    for (const entry of historyItem.entries) {
        if (entry.visualAnchorSide === 'left') {
            return 'left';
        }
        if (entry.visualAnchorSide === 'right') {
            return 'right';
        }
        for (const value of [entry.oldValue, entry.newValue]) {
            if (typeof value !== 'string') {
                continue;
            }
            if (value.startsWith('LEFT ')) {
                return 'left';
            }
            if (value.startsWith('RIGHT ')) {
                return 'right';
            }
        }
    }
    return null;
}
export function refreshLiveGlyphAdvancesWithSelectedGlyphAnchor(target, glyphAdvanceDeltas, options = {}) {
    const precedingDelta = target.textRunEditor?.computePrecedingAdvanceDelta?.(Object.fromEntries(Object.entries(glyphAdvanceDeltas).map(([glyphName, advanceDelta]) => {
        const intrinsicAdvance = target.textRunEditor.intrinsicGlyphAdvances?.get(glyphName);
        return [
            glyphName,
            typeof intrinsicAdvance === 'number'
                ? intrinsicAdvance + advanceDelta
                : NaN
        ];
    }))) ?? 0;
    const advancesRefreshed = target.textRunEditor?.refreshGlyphAdvanceDeltasLive(glyphAdvanceDeltas, options) ?? false;
    const viewportManager = target.viewportManager;
    if (advancesRefreshed &&
        Number.isFinite(precedingDelta) &&
        Math.abs(precedingDelta) > 0.01 &&
        viewportManager &&
        Number.isFinite(viewportManager.scale)) {
        viewportManager.panX -= precedingDelta * viewportManager.scale;
    }
    return advancesRefreshed;
}
export function applyLiveSidebearingVisualSync(target, options) {
    const previousWidth = Number(options.previousWidth);
    const nextWidth = Number(options.nextWidth);
    if (!Number.isFinite(previousWidth) || !Number.isFinite(nextWidth)) {
        return { widthDelta: 0, advancesRefreshed: false };
    }
    const widthDelta = nextWidth - previousWidth;
    if (Math.abs(widthDelta) <= 0.01) {
        return { widthDelta, advancesRefreshed: false };
    }
    const liveGlyphAdvanceDeltas = options.glyphAdvanceDeltas &&
        Object.keys(options.glyphAdvanceDeltas).length > 0
        ? options.glyphAdvanceDeltas
        : options.glyphName
            ? { [options.glyphName]: widthDelta }
            : null;
    const advancesRefreshed = !!liveGlyphAdvanceDeltas &&
        refreshLiveGlyphAdvancesWithSelectedGlyphAnchor(target, liveGlyphAdvanceDeltas, { render: options.render });
    return { widthDelta, advancesRefreshed };
}
export function syncModelSidebearingEditToCanvas(target, options) {
    target.syncCurrentOutlineLayerDataFromModel?.(options.layer);
    return applyLiveSidebearingVisualSync(target, {
        glyphName: options.glyphName,
        side: options.side,
        previousWidth: options.previousWidth,
        nextWidth: options.layer.width,
        render: options.render
    });
}
